import { c as _c } from "react/compiler-runtime";
import type { PageItem } from '@module/apis/type';
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from '@pc/components/ui/pagination';
const maxPageListLength = 10;
type SetCurrentPageFunction = ((page: number | ((prev: number) => number)) => void) // React useState 스타일
| ((page: number) => void); // 간단한 setter 스타일

interface BasePagenationProps {
  currentPage: number;
  setCurrentPage: SetCurrentPageFunction;
  pageData: PageItem | undefined;
}
function BasePagenation(t0) {
  const $ = _c(22);
  const {
    currentPage,
    setCurrentPage,
    pageData
  } = t0;
  const lastPage = pageData?.lastPage ?? 1;
  let t1;
  if ($[0] !== currentPage || $[1] !== setCurrentPage) {
    t1 = pageOrUpdater => {
      if (typeof pageOrUpdater === "function") {
        const newPage = pageOrUpdater(currentPage);
        setCurrentPage(newPage);
      } else {
        setCurrentPage(pageOrUpdater);
      }
    };
    $[0] = currentPage;
    $[1] = setCurrentPage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const safeSetCurrentPage = t1;
  const currentPageListLength = Math.min(lastPage - Math.floor((currentPage - 1) / 10) * 10, maxPageListLength);
  let t2;
  if ($[3] !== currentPage || $[4] !== currentPageListLength) {
    let t3;
    if ($[6] !== currentPage) {
      t3 = (_, idx) => Math.floor((currentPage - 1) / 10) * 10 + idx + 1;
      $[6] = currentPage;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = Array.from({
      length: currentPageListLength
    }, t3);
    $[3] = currentPage;
    $[4] = currentPageListLength;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const pageNumberList = t2;
  const isEmpty = !pageData || pageData.total === 0;
  const isFirstPageList = currentPage < 11;
  const isLastPageList = currentPageListLength < 10 || Math.ceil(currentPage / 10) * 10 === lastPage;
  if (isEmpty) {
    return null;
  }
  let t3;
  if ($[8] !== isFirstPageList || $[9] !== safeSetCurrentPage) {
    t3 = !isFirstPageList && <PaginationItem><PaginationPrevious href="#" onClick={() => safeSetCurrentPage(_temp)} /></PaginationItem>;
    $[8] = isFirstPageList;
    $[9] = safeSetCurrentPage;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== currentPage || $[12] !== pageNumberList || $[13] !== safeSetCurrentPage) {
    t4 = pageNumberList.map(num => <PaginationItem key={num}><PaginationLink href="#" onClick={() => safeSetCurrentPage(num)} isActive={currentPage === num}>{num}</PaginationLink></PaginationItem>);
    $[11] = currentPage;
    $[12] = pageNumberList;
    $[13] = safeSetCurrentPage;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isLastPageList || $[16] !== safeSetCurrentPage) {
    t5 = !isLastPageList && <PaginationItem><PaginationNext href="#" onClick={() => safeSetCurrentPage(_temp2)} /></PaginationItem>;
    $[15] = isLastPageList;
    $[16] = safeSetCurrentPage;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = <Pagination><PaginationContent>{t3}{t4}{t5}</PaginationContent></Pagination>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
function _temp2(prev_0) {
  if (prev_0 % 10 === 0) {
    return prev_0 + 1;
  }
  return Math.floor((prev_0 + 10) / 10) * 10 + 1;
}
function _temp(prev) {
  return Math.ceil((prev - 10) / 10) * 10;
}
export default BasePagenation;